import { useEffect, useRef } from "react";
import { router, usePage } from "@inertiajs/react";
import { pageview, setUserProperties, isGaEnabled } from "../lib/gtag";

interface AuthProps {
  player?: {
    player_id?: string;
    gender?: string;
    age_group?: string;
  };
  logged_in?: boolean;
}

interface PageProps {
  auth?: AuthProps;
  [key: string]: unknown;
}

export const useGoogleAnalytics = (): void => {
  const { props } = usePage<PageProps>();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (isGaEnabled()) {
      const player = props.auth?.player;
      if (player) {
        setUserProperties({
          player_id: player.player_id,
          gender: player.gender,
          age_group: player.age_group,
        });
      }

      pageview(window.location.pathname + window.location.search);
    }

    router.on("navigate", event => {
      pageview(event.detail.page.url);
    });
  }, []);
};
